import React, { createContext, memo, useState } from "react";
import { LoyaltyService } from "../services/loyalty.service";

interface IRegisterContext {
  termsAndConditionsVisible: boolean;
  registrationFormValues: ILoyaltyFormValues | null;
  otpVerificationVisible: boolean;
  requestId: string | null;
  registerSuccessfull: boolean;
  setRegisterSuccessfull: (success: boolean) => void;
  toggleTermsAndConditions: () => void;
  toggleOtpVerification: () => void;
  setRegistrationFormValues: (values: ILoyaltyFormValues | null) => void;
  registerCard: (
    values: ILoyaltyFormValues,
    recaptchaToken: string
  ) => Promise<void>;
  validateOtp: (
    requestId: string,
    otp: string,
    recaptchaToken: string
  ) => Promise<any>;
  resendOtp: (requestId: string, recaptchaToken: string) => Promise<void>;
  resetState: () => void;
}

const initialState: IRegisterContext = {
  termsAndConditionsVisible: false,
  otpVerificationVisible: false,
  registrationFormValues: null,
  requestId: null,
  registerSuccessfull: false,
  setRegisterSuccessfull: (sucess: boolean) => {},
  toggleTermsAndConditions: () => {},
  toggleOtpVerification: () => {},
  setRegistrationFormValues: (values: ILoyaltyFormValues | null) => {},
  registerCard: (values: ILoyaltyFormValues, recaptchaToken: string) =>
    Promise.resolve(),
  validateOtp: (requestId: string, otp: string, recaptchaToken: string) =>
    Promise.resolve(),
  resendOtp: (requestId: string, recaptchaToken: string) => Promise.resolve(),
  resetState: () => {},
};

const RegisterContext = createContext<IRegisterContext>(initialState);

export const RegisterProvider = memo((props: any) => {
  const [state, setState] = useState<IRegisterContext>({
    ...initialState,
    setRegisterSuccessfull: (success: boolean) => {
      setState((state) => ({
        ...state,
        registerSuccessfull: success,
      }));
    },
    toggleTermsAndConditions: () => {
      setState((state) => ({
        ...state,
        termsAndConditionsVisible: !state.termsAndConditionsVisible,
      }));
    },
    toggleOtpVerification: () => {
      setState((state) => ({
        ...state,
        otpVerificationVisible: !state.otpVerificationVisible,
      }));
    },
    setRegistrationFormValues: (values: ILoyaltyFormValues | null) => {
      setState((state) => ({
        ...state,
        registrationFormValues: values,
      }));
    },
    registerCard: async (
      values: ILoyaltyFormValues,
      recaptchaToken: string
    ) => {
      const registerResponse = await LoyaltyService.registerCard(
        values,
        recaptchaToken
      );
      if (registerResponse.data) {
        setState((state) => {
          return {
            ...state,
            registrationFormValues: values,
            otpVerificationVisible: true,
            requestId: registerResponse.data.requestId,
          };
        });
      }
      return registerResponse;
    },
    validateOtp: async (
      requestId: string,
      otp: string,
      recaptchaToken: string
    ) => {
      const validateResponse = await LoyaltyService.validateOtp(
        requestId,
        otp,
        false,
        recaptchaToken
      );
      return validateResponse;
    },
    resendOtp: async (requestId: string, recaptchaToken: string) => {
      await LoyaltyService.resendOtp(requestId, recaptchaToken);
    },
    resetState: () => {
      setState((state) => ({
        ...state,
        termsAndConditionsVisible: false,
        otpVerificationVisible: false,
        registrationFormValues: null,
        requestId: null,
        registerSuccessfull: false,
        verificationCount: null,
      }));
    },
  });

  return (
    <RegisterContext.Provider value={state}>
      {props.children}
    </RegisterContext.Provider>
  );
});

export default RegisterContext;
